export enum CustomerStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}
